import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/actionplan-actions');
  }

  tasks = async () => {
    return api.get(this.buildUrl('tasks'));
  };
}

export default new API();
